import EventActionProto from '../event-action-proto';
import AssignedTasksCollection from "src/core/gd-model/assigned-tasks/assigned-tasks-collection";

// here we trully reset our collection which kills all other data....

module.exports = class EventAssignedTasksReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
    }

    process() {
        if (!gd.session.assignedTasks) gd.session.assignedTasks = new AssignedTasksCollection();

        gd.session.assignedTasks.resetFull(this.data);
        // super.process();
    }
};

